import { useDispatch } from "react-redux";
import { routes } from "../../assets/constants";
import { ApiMethod } from "../models/api-types.type";
import { buildQueryParams } from "../utils/utils";
import { useAuthContext } from "./use-auth-context.hook";
import { User } from "../models/user.model";

export const useUsersApi = () => {
    const { sendAuthGuardedRequest,  } = useAuthContext();
    const dispatch = useDispatch()

    const findAllUsers = async (
        limit?: number,
        offset?: number,
      ): Promise<any> => {
        const queryString = buildQueryParams([
          { key: "limit", value: limit?.toString() },
          { key: "offset", value: offset?.toString() },
        ]);
    
        const response: any = await sendAuthGuardedRequest(
          ApiMethod.GET,
          routes.users.findAll + queryString,
        )
        return response
    };

    const findOneUserAndDelete = async (id: string): Promise<any> => {
        await sendAuthGuardedRequest(
          ApiMethod.DELETE, 
          routes.users.deleteOne(id)
        )
    };

    const updateUser = async (user): Promise<any> => {
        return await sendAuthGuardedRequest(
          ApiMethod.PATCH, 
          routes.users.patch,
          user
        )
    }; 

    const findOneUser = async (id: string): Promise<User> => {
        return await sendAuthGuardedRequest(
          ApiMethod.GET,
          routes.users.findOne(id),
        ) as User;
    };
    
    
    return { 
        findAllUsers,
        findOneUserAndDelete,
        updateUser,
        findOneUser
    };


};
  